module.exports = __webpack_public_path__ + "media/images/actualizar-9f8a25ce07cebc06c545275785fcf308.svg";